import { QRCode } from 'antd'
import { development } from 'app/config/constants'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'

type Props = {
  link: string
  size: number
  pad?: number
}

export const Qr = observer(({ link, size, pad = 0 }: Props) => {
  const onClick = useLatestCallback(() => {
    if (development) window.open(link, '_blank')
  })

  return <Space pad={pad} center onClick={onClick}>
    <QRCode value={link} type="svg" size={size - 2 * pad} bordered={false} />
  </Space>
})
